export default __webpack_public_path__ + "60d6ba88fa55d7a05c884af340db17da.png";